module.exports = __webpack_public_path__ + "img/1KtVG8Xn7Oi-FoCxa0ZdOG.aadcf480.svg";